module.exports = __webpack_public_path__ + "app-static/img/p_13.3cf0f1f6.jpg";